<!-- eslint-disable -->
<template lang="pug">
    .play-box
        template(v-if='!isLoading')
            game-preparation-counter(v-if='!gameStarted && counter' :counter="counter")
            template(v-else="")
                game-header(
                    @soundStateChanged ="headerKey = !headerKey",
                    :time="getTime",
                    :key="headerKey"
                    :slug='type',
                    :game-type='parameters && parameters.courseType',
                    :is-homework="!!exerciseId",
                )
                .play-box__game(v-if='gameStarted && !gameFinished || showUnselectedLetters')
                    .play-box__example
                        .play-box__top-block(:class="{'mobile-version'  : isMobile}")
                            .play-box__header
                                .play-box__title
                                    | {{ $i18n.t('trainer.trainer_game_lettersField_findLetters') }}
                                .play-box__subtitle(:style="letterStyle")
                                    span.play-box__letter(v-for='letter in neededLetters')
                                        | {{ letter }}
                            .play-box__scaling-bar-block
                                scaling-bar(
                                    @setFontSize="setFontSize"
                                    :is-game-tuned="true"
                                    :font-size="fontSize"
                                    element-name="play-box__field"
                                    :is-from-shutter="false"
                                    :scale-element="$i18n.tc('trainer.trainer_gamePlayBox_letters')"
                                    :key="clientWidth"
                                )
                                .play-box__buttons.play-box__buttons--game
                                    cs-button.play-box__button(
                                        v-if='!showUnselectedLetters'
                                        :disabled='selectedLetters.length === 0',
                                        @click='processReply'
                                        :style="letterStyle"
                                    )
                                        | {{ $i18n.t('trainer.trainer_gamePlayBox_reply') }}
                                    cs-button.play-box__button(
                                        v-else=""
                                        @click='showUnselectedLetters = false'
                                        :style="letterStyle"
                                    )
                                        | {{ $i18n.t('olympiads.olympiads_processStage_further') }}
                        .play-box__overflow-container
                            .play-box__field
                                template(v-if="!isLessThanCalculationsFontSize")
                                    template(v-for='(line, indexOfLine) in displayedLines')
                                        span.play-box__letter(
                                            :class="letterClass(letter, indexOfLine, indexOfLetter)",
                                            v-for='(letter, indexOfLetter) in line',
                                            @click='selectLetter(letter, indexOfLine, indexOfLetter)'
                                            :style="letterStyle"
                                        )
                                            | {{ letter }}
                                template(v-else)
                                    .play-box__letters-row(v-for='(line, indexOfLine) in displayedLines')
                                        span.play-box__letter(
                                            :class="letterClass(letter, indexOfLine, indexOfLetter)",
                                            v-for='(letter, indexOfLetter) in line',
                                            @click='selectLetter(letter, indexOfLine, indexOfLetter)'
                                            :style="letterStyle"
                                        )
                                            | {{ letter }}
                .play-box__end-container(v-if='gameFinished && !isOlympiad && !showUnselectedLetters')
                    fireworks(
                        v-if="gameFinished && !isOlympiad"
                        :is-mobile="isMobile"
                    )
                    .play-box__reaction-container
                        .play-box__answers-container(v-if="!isMobile")
                            .play-box__answers.play-box__answers--left
                                | {{ $i18n.t('trainer.trainer_game_wordField_yourTime') }}
                                br
                                | {{ getTime }}
                            .play-box__answers.play-box__answers--right
                                | {{ $i18n.t('trainer.trainer_game_lettersField_foundLetters') }}
                                br
                                | {{ resultLetters.length }} / {{ amountOfLettersToFind }}
                        .play-box__answers.play-box__answers--left.play-box__answers--show-md
                            | {{ $i18n.t('trainer.trainer_game_wordField_yourTime') }}
                            br
                            | {{ getTime }}
                        result-image.play-box__image(status="success")
                        .play-box__answers.play-box__answers--right.play-box__answers--show-md
                            | {{ $i18n.t('trainer.trainer_game_lettersField_foundLetters') }}
                            br
                            | {{ resultLetters.length }} / {{ amountOfLettersToFind }}
                    result-buttons(
                        :exercise-id="exerciseId"
                        :games-type="parameters.courseType"
                        show-restart-button
                        @restartGame="restartGame"
                    )
                        slot
        cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
    import _ from 'lodash';
    import ScalingBar from './ScalingBar.vue';
    import textScrollMixin from '../../../../utils/trainer/textScroll';
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import olympiadAnswerTimerMixin from '../../../../utils/olympiads/olympiadAnswerTimerMixin.js';
    import GamePreparationCounter from '../../GamePreparationCounter.vue';

    const MAX_AMOUNT_OF_SIMILAR_LETTERS = 7;
    const MIN_AMOUNT_OF_SIMILAR_LETTERS = 1;
    const LETTERS_IN_ALPHABET = 33;
    const DEFAULT_VOLUME = 0.6;
    const CALCULATIONS_FONT_SIZE = 20;
    const ALPHABETS = {
        ru: ['А','Б','В','Г','Д','Е','Ё','Ж','З','И','Й','К','Л','М','Н','О','П','Р','С','Т','У','Ф','Х','Ц','Ч','Ш','Щ','Ъ','Ы','Ь','Э','Ю','Я'],
        uk: ['А','Б','В','Г','Ґ','Д','Е','Є','Ж','З','И','І','Ї','Й','К','Л','М','Н','О','П','Р','С','Т','У','Ф','Х','Ц','Ч','Ш','Щ','Ь','Ю','Я'],
    }
    const ENGLISH_LETTERS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    function DEFAULT_DATA () {
        return {
            letters: ALPHABETS,
            neededLetters: [],
            selectedLetters: [],
            displayedLines: [],
            showNeededLetters: true,
            resultLetters: [],
            repetitionsOfLetters: {},
            showUnselectedLetters: false,
            fontSize: CALCULATIONS_FONT_SIZE,
            amountOfMistakes: 0,
            clientWidth: 0,
            amountOfLettersInRow: 26,
        }
    }

    export default {
        mixins: [textScrollMixin, playBoxGameMixin, olympiadAnswerTimerMixin],
        created () {
            window.addEventListener('resize', this.getClientWidth);
        },
        mounted () {
            this.gameBoxName = 'lettersField-game-container__interactive-place__field';
        },
        data () {
            return DEFAULT_DATA();
        },
        watch: {
            selectedLetters (array) {
                if (array.length === 0) {
                    window.removeEventListener('keydown', this.processReplyOnEnter);
                }
            }
        },
        computed: {
            amountOfLettersToFind () {
                return _.sum(Object.values(this.repetitionsOfLetters));
            },
            showGameHeader () {
                return !this.gameFinished && this.gameStarted || this.showUnselectedLetters;
            },
            letterStyle () {
                return {
                    'font-size': +this.fontSize + 'px',
                    'line-height': (+this.fontSize + 8) + 'px'
                }
            },
            isLessThanCalculationsFontSize() {
                return Number(this.fontSize) <= CALCULATIONS_FONT_SIZE;
            }
        },
        methods: {
            getLettersAmountInRow() {
                let clientWidth = document.documentElement.clientWidth
                this.amountOfLettersInRow = this.isMobile 
                    ? clientWidth < 500
                        ? Math.floor((clientWidth-clientWidth/5)/(this.fontSize+20))
                        : Math.floor((clientWidth-clientWidth/5)/(this.fontSize+20))-2
                    : 26;
            },
            getClientWidth() {
                this.clientWidth = document.documentElement.clientWidth;
                if (this.clientWidth < 576 && this.fontSize > 30) {
                    this.setFontSize(30);
                } else if (this.clientWidth < 766 && this.fontSize > 40) {
                    this.setFontSize(40);
                } else if (this.clientWidth < 1200 && this.fontSize > 60) {
                    this.setFontSize(60);
                } else if (this.clientWidth < 1430 && this.fontSize > 80) {
                    this.setFontSize(80);
                } else if (this.clientWidth < 1920 && this.fontSize > 100) {
                    this.setFontSize(100);
                } else if (this.clientWidth >= 1920){
                    this.setFontSize(150);
                }
            },
            fetchData() {
                this.getExercise()
                    .then(() => {
                        this.fillNeededLetters();
                        this.registerSounds();
                    })
                    .catch(e => {
                        this.isLoading = false;
                        this.$toasted.error(this.$root.$t('errors.getting_level'));
                        this.$router.push({ name: 'dashboard' });
                    });
            },
            refreshGameStatBeforeSend () {
                let arrayOfUniqAnswers = _.uniqBy(this.resultLetters, 'item');
                this.gameStat.answers = arrayOfUniqAnswers.length;
                this.gameStat.attempts = 1;
                this.gameStat.isCompleted = this.gameFinished;
                this.gameStat.executionTime = this.time;
                this.gameStat.chainOfAttempts = [];
                this.gameStat.isCorrect = true;
                this.gameStat.percent = parseInt((arrayOfUniqAnswers.length / this.neededLetters.length) * 100);
                this.gameStat.amountOfWords = 0;
                this.gameStat.parameters = _.cloneDeep(this.parameters);
            },
            beforeStart () {
                this.startGame();
            },
            startGame () {
                this.gameStarted = true;
                if (this.answerDuration) {
                    this.startAnswerTimer();
                }
                if (this.parameters.withTime) {
                    setTimeout(() => {
                        this.showNeededLetters = false;
                        this.startTimer();
                    }, this.parameters.showTime * 1000)
                } else {
                    this.startTimer();
                }
            },
            startTimer () {
                this.$nextTick(() => {
                    if (!this.timer) {
                        this.setTimer();
                    }
                });
            },
            fillNeededLetters () {
                this.getLettersAmountInRow();
                this.neededLetters = this.parameters.selectedLetters;
                let newLetters = [];
                let locale = 'ru';
                let count = 0;
                const allowedAlphabets = Object.entries(ALPHABETS);
                for (const [key, value] of allowedAlphabets) {
                    if (!ALPHABETS[this.user.locale]) {
                        break;
                    }
                    if (this.neededLetters.every(letter => value.includes(letter))) {
                        locale = key;
                        count++;
                    }
                    if (count === allowedAlphabets.length) {
                        locale = this.user.locale;
                    }
                }
                let letters = this.letters[locale];
                if (this.parameters.courseType === 'readingEn' || this.course === 'reading-en') {
                  letters = ENGLISH_LETTERS
                }
                this.letters = letters.concat(...Array.from({length: this.amountOfLettersInRow * this.parameters.amountOfRows / LETTERS_IN_ALPHABET}, () => letters));
                while (!this.neededLetters.every(element => newLetters.includes(element))) {
                    newLetters = [];
                    this.letters = _.shuffle(this.letters);
                    this.letters.forEach(letter => {
                        let length = this.getRandomInt(MIN_AMOUNT_OF_SIMILAR_LETTERS, MAX_AMOUNT_OF_SIMILAR_LETTERS);
                        for (let i = 0; i < length; i++) {
                            if (newLetters.length >= this.amountOfLettersInRow * this.parameters.amountOfRows) {
                                return;
                            }
                            newLetters.push(letter);
                        }
                    });
                }
                this.letters = newLetters;
                this.displayedLines = _.chunk(_.shuffle(this.letters), this.amountOfLettersInRow);
                this.letters.forEach(letter => {
                    if (this.neededLetters.includes(letter)) {
                        if (this.repetitionsOfLetters[letter]) {
                            ++this.repetitionsOfLetters[letter];
                        } else {
                            this.repetitionsOfLetters[letter] = 1;
                        }
                    }
                });
            },
            getRandomInt (min, max) {
                return Math.floor(Math.random() * (max - min)) + min;
            },
            selectLetter (letter, indexOfLine, indexOfLetter) {
                if (!this.showUnselectedLetters) {
                    let index = this.selectedLetters.findIndex( element => _.isEqual(element, {item: letter, line: indexOfLine, row: indexOfLetter}));
                    if (index !== -1) {
                        this.selectedLetters.splice(index, 1);
                    } else  {
                        if (this.selectedLetters.length === this.amountOfLettersToFind) {
                            return;
                        }
                        this.selectedLetters.push({item: letter, line: indexOfLine, row: indexOfLetter});
                    }
                    window.addEventListener('keydown', this.processReplyOnEnter);
                }
            },
            isLetterSelected (letter, indexOfLine, indexOfLetter) {
                return this.selectedLetters.find(element => {
                    return element.line === indexOfLine && element.row === indexOfLetter;
                });
            },
            isNeededLetterUnselected (letter, line, row) {
                if (this.gameFinished) {
                    return this.neededLetters.find(item => {
                        if (this.areLettersEqual(item, letter) && !this.isLetterSelected(letter, line, row)) {
                            return true;
                        }
                    });
                }
            },
            isUnwantedLetterSelected (letter, line, row) {
                if (this.gameFinished) {
                    let isLetterNeeded = false;
                    this.neededLetters.forEach(item => {
                        if (this.areLettersEqual(item, letter)) {
                            isLetterNeeded = true;
                        }
                    });
                    return !isLetterNeeded && this.isLetterSelected(letter, line, row);
                }
            },
            processReply () {
                this.stopTimer();
                window.removeEventListener('keydown', this.processReplyOnEnter);
                this.resultLetters = this.selectedLetters.filter(item => {
                    for (let i = 0; i < this.neededLetters.length; i++) {
                        if (this.areLettersEqual(item, this.neededLetters[i])) {
                            return item;
                        } else {
                            this.amountOfMistakes++;
                        }
                    }
                });
                if (this.resultLetters.length < this.amountOfLettersToFind) {
                    this.showUnselectedLetters = true;
                    setTimeout(() => window.addEventListener('keydown', this.finishGameOnEnter), 100);
                }
                this.gameFinished = true;
                this.sendStat();
            },
            areLettersEqual (first, second) {
                return first === second || first.item && (first.item === second);
            },
            setFontSize (fontSize) {
                this.fontSize = fontSize;
            },
            processReplyOnEnter (event) {
                if (event.keyCode === 13) {
                    this.processReply();
                }
            },
            finishGameOnEnter (event) {
                if (event.keyCode === 13) {
                    this.showUnselectedLetters = false;
                }
            },
            beforeGameRestart() {
                Object.assign(this.$data, DEFAULT_DATA());
            },
            letterClass (letter, indexOfLine, indexOfLetter) {
                return {
                    'play-box__letter--selected': this.isLetterSelected(letter, indexOfLine, indexOfLetter),
                    'play-box__letter--unselected': (
                            this.isNeededLetterUnselected(letter, indexOfLine, indexOfLetter)
                            || this.isUnwantedLetterSelected(letter, indexOfLine, indexOfLetter)
                    ) && !this.isOlympiad,
                    'play-box__letter--inverted': this.parameters.invertedLetters
                }
            }
        },
        beforeDestroy() {
            window.removeEventListener('keydown', this.finishGameOnEnter);
            window.removeEventListener('resize', this.getClientWidth);
        },
        components: {
            GamePreparationCounter,
            ScalingBar,
        },
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/sass/games/playbox.scss";

    .play-box--warning {
        display: table;
    }

    .play-box__game {
        display: flex;
        flex: 1 1 auto;
        flex-direction: column-reverse;
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__example {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-grow: 5;
        flex-direction: column;
    }

    .play-box__top-block {
        display: flex;
    }

    .mobile-version {
        flex-direction: column;
        text-align: center;
        align-items: center;
    }

    .play-box__scaling-bar-block {
        margin-left: 20px;
        @include media($xlg) {
            margin-left: 40px;
        }
    }

    .play-box__overflow-container {
        overflow-y: auto;
        @include scrollbar;
    }

    .play-box__field {
        padding: 0 20px;
        text-align: center;
        font-size: 18px;
        user-select: none;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .play-box__letters-row {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .play-box__answer-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .answer-container__header {
        margin-bottom: 20px;
        font-weight: 500;
        font-size: 32px;
        line-height: 38px;
    }

    .answer-container__input .cs-input {
        margin-bottom: 0;
        font-size: 52px;
        line-height: 62px;
        padding: 9px 15px;
        text-align: center;
        max-width: 330px;
    }

    .play-box__letter {
        padding: 0 8px;
        margin: 0 10px 3px 0;
        cursor: pointer;
    }

    .play-box__letter:last-child {
        margin-right: 0;
    }

    .play-box__letter--selected {
        color: $x-color-white;
        background: $hsl-color-green-58;
    }

    .play-box__letter--unselected {
        color: $x-color-white;
        background: $hsl-color-red-62;
    }

    .play-box__letter--inverted {
        display: inline-block;
        transform: rotate(180deg);
        margin-right: 10px;
    }

    .play-box__header {
        max-width: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-weight: 500;
        font-size: 28px;
        line-height: 34px;
        margin-bottom: 20px;
    }

    .play-box__title {
        margin-bottom: 20px;
    }

    .play-box__subtitle {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 0;
        justify-content: center;
    }

    .play-box__end-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .play-box__reaction-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
        width: 100%;
    }

    .play-box__answers {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        @include media($lg) {
            font-size: 32px;
            line-height: 38px;
        }
        @include media($xl) {
            font-size: 42px;
            line-height: 50px;
        }
    }

    .play-box__answers--left {
        color: $hsl-color-green-58;
        margin-left: 20px;
        @include media($lg) {
            margin-left: 35px;
        }
    }

    .play-box__answers--right {
        color: $hsl-color-green-58;
        margin-right: 20px;
        @include media($lg) {
            margin-right: 35px;
        }
    }

    .play-box__answers--show-md {
        display: block;
    }

    .play-box__answers-container {
        display: flex;
        width: 100%;
        justify-content: space-between;
        @include media($md) {
            display: none;
        }
    }

    .play-box__image {
        max-width: 100%;
        margin-bottom: 40px;
    }

    .play-box__buttons {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-top: 25px;
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__buttons--game {
        margin: 0 0 25px;
    }

    .play-box__button {
        margin: 20px 0;
        @include media($lg) {
            margin: 0 20px;
        }
    }

    .play-box__button:first-child {
        margin-top: 0;
        @include media($lg) {
            margin-left: 0;
        }
    }

    .play-box__button:last-child {
        margin-bottom: 0;
        @include media($lg) {
            margin-right: 0;
        }
    }

    .play-box__game-info {
        align-self: flex-end;
        @include media($lg) {
            align-self: auto;
        }
    }

    .warning {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }
</style>
